/**
 * QuoteSortControls - Sort dropdown for quotes section
 */

const SORT_OPTIONS = [
  { value: 'none', label: 'Default' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'time-asc', label: 'Time: Fastest' },
  { value: 'time-desc', label: 'Time: Slowest' },
];

const QuoteSortControls = ({ sortBy, onSortChange }) => {
  return (
    <select
      value={sortBy}
      onChange={(e) => onSortChange(e.target.value)}
      className="text-xs px-2 py-1 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 focus:ring-2 focus:ring-primary/20 focus:border-primary"
    >
      {SORT_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
};

export const sortQuotes = (quotes, sortBy) => {
  if (sortBy === 'none' || !sortBy) return quotes;

  const calculateTotal = (q) => (q.executionFee || 0) + (q.travelFee || 0) + (q.otherFee || 0);

  return [...quotes].sort((a, b) => {
    switch (sortBy) {
      case 'price-asc':
        return calculateTotal(a) - calculateTotal(b);
      case 'price-desc':
        return calculateTotal(b) - calculateTotal(a);
      case 'time-asc':
        return (a.promisedPostingTimeInMinutes || 0) - (b.promisedPostingTimeInMinutes || 0);
      case 'time-desc':
        return (b.promisedPostingTimeInMinutes || 0) - (a.promisedPostingTimeInMinutes || 0);
      default:
        return 0;
    }
  });
};

export default QuoteSortControls;
